export const GET_EVALUATE_PROGRESS_STATUS_LIST = "GET_EVALUATE_PROGRESS_STATUS_LIST";
export const GET_EVALUATE_PROGRESS_LIST = "GET_EVALUATE_PROGRESS_LIST";
